export function buildVenueInfoWindowDom({ venue, color, onViewDetails }) {
  const root = document.createElement("div");
  root.style.cssText = "padding:10px; max-width:280px; font-family: Inter, sans-serif;";

  const title = document.createElement("h3");
  title.style.cssText = "font-size:15px; font-weight:600; color:#1f2937; margin:0 0 6px 0;";
  title.textContent = venue.store_name || venue.venue_name;
  root.appendChild(title);

  const details = document.createElement("div");
  details.style.cssText = "font-size:12px; color:#6b7280; line-height:1.5;";
  details.innerHTML = `
    <p style="margin:3px 0;"><strong>Address:</strong> ${venue.address ?? ""}</p>
    <p style="margin:3px 0;"><strong>City:</strong> ${venue.city ?? ""}, ${venue.state ?? ""} ${venue.zipcode ?? ""}</p>
    <p style="margin:3px 0;"><strong>Type:</strong> <span style="color:${color}; font-weight:600;">${venue.venue_type ?? "Other"}</span></p>
  `;
  root.appendChild(details);

  const btn = document.createElement("button");
  btn.type = "button";
  btn.textContent = "View Details";
  btn.style.cssText = `
    width:100%;
    margin-top:8px;
    padding:6px 12px;
    background:${color};
    color:white;
    border:none;
    border-radius:4px;
    font-weight:600;
    font-size:12px;
    cursor:pointer;
  `;
  btn.addEventListener("click", onViewDetails);
  root.appendChild(btn);

  return root;
}

/**
 * Opens (and reuses) a shared InfoWindow for a venue.
 */
export function openSharedVenueInfoWindow({
  sharedInfoWindow,
  map,
  anchor,
  venue,
  color,
  onViewDetails,
}) {
  if (!sharedInfoWindow) return;

  const content = buildVenueInfoWindowDom({ venue, color, onViewDetails });
  sharedInfoWindow.setContent(content);
  sharedInfoWindow.open({ map, anchor });
}